import { useToast } from "@chakra-ui/react";
import { useEffect, useRef, useCallback, useContext } from "react";
import { PtSiteCtx } from "../CustomSiteF/CustomSiteWrapperF.jsx";
import { isIgnorableJsErrMsg } from "../../sharedF/throwErrorF/constantsF.mts";
export const useErrorToast = () => {
    const toast = useToast();
    return useCallback((opts) => {
        toast({
            status: 'error',
            duration: null,
            isClosable: true,
            ...opts,
        });
    }, [toast]);
};
export const useOneToast = (toastObj) => {
    const toastIdRef = useRef(undefined);
    const toast = useToast();
    useEffect(() => {
        if (!toastObj)
            return () => { };
        if (toastIdRef.current != null) {
            toast.close(toastIdRef.current);
        }
        toastIdRef.current = toast({
            duration: null,
            isClosable: true,
            ...toastObj,
        });
        return () => { };
    }, [toastObj]);
};
export const useToastOnError = ({ error }) => {
    const { fmtSiteError } = useContext(PtSiteCtx);
    const isIgnorable = error instanceof Error && isIgnorableJsErrMsg(error.message);
    useOneToast(error && !isIgnorable ? {
        title: 'Error',
        description: fmtSiteError({ error }),
        status: 'error',
    } : undefined);
};
